import Skeleton from '@mui/material/Skeleton'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { sensemakerTableBodyCellSx, sensemakerTableBodyCellInteractiveSx } from '@/shared/table'

type Props = Readonly<{
  rowCount?: number
}>

export function UserListTableSkeleton({ rowCount = 10 }: Props) {
  return (
    <>
      {Array.from({ length: rowCount }, (_, index) => (
        <TableRow
          key={index}
          sx={{ '&:last-child td': { borderBottom: index === rowCount - 1 ? 0 : undefined } }}
        >
          <TableCell sx={sensemakerTableBodyCellSx}>
            <Skeleton variant="text" width={56} height={20} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellSx}>
            <Skeleton variant="text" width="72%" height={20} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellSx}>
            <Skeleton variant="text" width="85%" height={20} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellSx}>
            <Skeleton variant="text" width={64} height={20} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellInteractiveSx}>
            <Skeleton variant="rounded" width={72} height={24} sx={{ borderRadius: '999px' }} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellSx}>
            <Skeleton variant="text" width={88} height={20} />
          </TableCell>
          <TableCell sx={sensemakerTableBodyCellInteractiveSx}>
            <Skeleton variant="rounded" width={72} height={24} sx={{ borderRadius: '6px', ml: 'auto' }} />
          </TableCell>
        </TableRow>
      ))}
    </>
  )
}
